export type PSAKeys = 'appDownloadPSA' | 'siteMaintenancePSA_may27th'

export const PSA_BANNER_KEYS: { [x: string]: PSAKeys } = {
  APP_DOWNLOAD: 'appDownloadPSA',
  SITE_MAINTENANCE: 'siteMaintenancePSA_may27th',
}

type PSABannerContent = {
  /**
   * Default value - shouldn't be removed before adding any new campaigns
   */
  [x in PSAKeys]: {
    /**
     * Defines if the PSA banner has highlighted text
     * This title will show in Yellow
     * @default false
     */
    hasHighlightedTitle?: boolean
    /**
     * Translation key to access the psa banner translation
     */
    intlKey: string
    /**
     * PSA banner tracking key
     */
    psaKey: string
    /**
     * Start Date of the campaign
     */
    startDate?: Date
    /**
     * End Date of the campaign
     */
    endDate?: Date
  }
}

/**
 * Make sure to clean up old marketing campaigns that won't be used anymore when adding new ones
 * */
export const PSA_BANNER: PSABannerContent = {
  appDownloadPSA: {
    intlKey: 'app_download',
    psaKey: PSA_BANNER_KEYS.APP_DOWNLOAD,
  },
  siteMaintenancePSA_may27th: {
    intlKey: 'site_maintenance',
    psaKey: PSA_BANNER_KEYS.SITE_MAINTENANCE,
    /**
     * We currently don't handle timezones
     */
    startDate: new Date('2025-05-26T09:00:00'),
    endDate: new Date('2025-05-27T05:00:00'),
  },
}
